import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.form = this.element.closest("form");
    if (!this.form) {
      console.warn("Couldn't find form to interact with");
      return;
    }

    this.check();
    this.element.addEventListener("click", (e) => {
      this.defaultInputs().forEach((input) => {
        if (input.getAttribute("data-default")) {
          input.click();
        }
      });
      this.form.submit();
    });

    this.form.addEventListener("change", (e) => this.check());
  }

  defaultInputs() {
    return Array.prototype.slice
      .call(this.form.getElementsByTagName("input"))
      .filter((input) => input.getAttribute("data-default"));
  }

  check() {
    const uncheckedInput = this.defaultInputs().find((input) => !input.checked);
    if (uncheckedInput) {
      this.element.classList.remove("disabled");
      this.element.removeAttribute("disabled");
    } else {
      this.element.classList.add("disabled");
      this.element.setAttribute("disabled", true);
    }
  }
}
